
import { Component, Vue, Prop } from 'vue-property-decorator'
import StatusDot from '@/components/status_dot/index.vue'

@Component({
    name: 'company-settle-table',
    components: {
        StatusDot
    }
})
export default class CompanyTable extends Vue {
    @Prop({ required: true }) private value!: any[]
    private statusOption = {
        Ing: 1,
        Pass: 2,
        Fail: 3
    }

    private onGoDetail(person: any) {
        const href = `/person/settle/${person.id}` 
        window.open(href, '_blank')
    }
}
